module.exports = __webpack_public_path__ + "svgs/system-jumping.8797966c.svg";